export default function NoCleanupRequiredSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Absolutely <span className="text-teal-600">No Cleanup Required</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leave everything exactly as it is. We handle all the heavy lifting, sorting, removal, and disposal.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/84f14a9174eab9a8dcca49b1b759951a.jpg"
              alt="Professional cleanup team at work"
              className="w-full h-96 object-cover rounded-xl shadow-lg"
            />
          </div>

          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">What We Handle For You</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-delete-bin-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Complete Junk Removal</h4>
                  <p className="text-gray-700 text-sm">We remove all unwanted items, from furniture and appliances to boxes, papers, and personal belongings. Nothing is too much for our experienced team.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-recycle-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Responsible Disposal</h4>
                  <p className="text-gray-700 text-sm">We sort through items and donate what we can to local charities, recycle appropriate materials, and dispose of the rest responsibly and legally.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-sparkling-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Deep Cleaning Services</h4>
                  <p className="text-gray-700 text-sm">After removal, we arrange for professional cleaning services to address any sanitation concerns, odors, or residue left behind.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-bug-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Pest Control</h4>
                  <p className="text-gray-700 text-sm">If needed, we coordinate professional pest control services to address any infestations that may have developed in the property.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-tools-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Minor Repairs</h4>
                  <p className="text-gray-700 text-sm">We handle any necessary repairs or restoration work after cleanup, from patching walls to addressing flooring issues caused by excessive weight.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Safe Handling</h4>
                  <p className="text-gray-700 text-sm">Our team follows proper safety protocols when dealing with potentially hazardous materials, biohazards, or structural concerns.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-10 text-white">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">You Keep What Matters</h3>
              <p className="text-gray-300 mb-4 leading-relaxed">
                While we handle all the cleanup, we understand that some items may have sentimental or monetary value. Before we begin the removal process, you have the opportunity to identify and retrieve any items you want to keep.
              </p>
              <p className="text-gray-300 leading-relaxed">
                We can also work with you to identify potentially valuable items like jewelry, collectibles, important documents, or family heirlooms. Our team takes care to look for these items during the cleanup process and set them aside for your review.
              </p>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=person%20carefully%20holding%20vintage%20family%20photo%20album%20and%20precious%20keepsakes%20sentimental%20items%20memories%20preserved%20warm%20emotional%20moment%20soft%20natural%20lighting%20close%20up%20hands%20protecting%20valuables&width=700&height=700&seq=hoarder-keepsakes-006&orientation=squarish"
                alt="Preserving valuable and sentimental items"
                className="w-full h-96 object-cover rounded-xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
